import { Component, OnInit } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import {LiveEventAdapter} from '../../models/live-event/live-event';
import {ContentfulService} from '../../services/contentful.service';
import * as moment from 'moment';
import {AngularFireFunctions} from '@angular/fire/functions';
import {loadStripe} from '@stripe/stripe-js/pure';
import {AngularFireAuth} from '@angular/fire/auth';
import {take} from 'rxjs/operators';
import {AngularFirestore} from '@angular/fire/firestore';
import {AngularFireDatabase} from '@angular/fire/database';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
})
export class AdminComponent implements OnInit {
  eventsList = [];
  selectedEvent;
  email;
  accessFunction;
  updatePasswordFunction;
  loading;
  passwordLoading = false;
  showSuccess;
  showError;
  showPasswordSuccess;
  showPasswordError;
  password;
  useremail;
  showAlertSuccess;
  showAlertError;
  alertMessage = "asdf";
  test = "Hi";
  alertOn = false;
  alertMessageLoading = false;
  topAlertSetting;
  constructor(public firebaseAuth: AngularFireAuth, private contentfulService: ContentfulService, private fns: AngularFireFunctions, private db: AngularFireDatabase) {
    this.accessFunction = fns.httpsCallable('stripe-grantEventAccess');
    this.updatePasswordFunction = fns.httpsCallable('user-updateUserPassword');
    this.db.object("admin/topAlertSetting").valueChanges().subscribe((res) => {
      this.topAlertSetting = res;
    });
    this.db.object("admin/topAlertMessage").valueChanges().subscribe((res: string) => {
      this.alertMessage = res;
    });
  }

  ngOnInit() {
    const n = moment().subtract(4, 'hours').format();
    this.contentfulService.getLiveEvents({order: 'fields.startDate', 'fields.startDate[gte]': n}).then((res) => {
      res.forEach((entry) => {
        const live = new LiveEventAdapter().creatLiveEventFromEntry(entry);
        this.eventsList = [...this.eventsList, {
          value: live.id,
          label: live.title
        }];
      });
      this.selectedEvent = this.eventsList[0];
    });
  }

  grantEventAccess() {
    if (this.email && this.selectedEvent.value) {
      this.loading = true;
      this.accessFunction({ entryId: this.selectedEvent.value, email: this.email}).subscribe(async (res) => {
        if (res.message === 'success') {
          this.email = '';
          this.selectedEvent = null;
          this.loading = false;
          this.showSuccess = true;
          const self = this;
          setTimeout(function() {
            self.showSuccess = false;
          }, 1500);
        } else if (res.message === 'failed') {
          this.loading = false;
          this.showError = true;
        }
      });
    }
  }

  saveAlertMessage() {
    this.db.object('admin/topAlertMessage').set(this.alertMessage);
  }

  toggleAlertMessage(event) {
    this.db.object('admin/topAlertSetting').set(this.topAlertSetting);
  }

  resetUserPassword() {
    if (this.useremail && this.password) {
      this.showPasswordSuccess = false;
      this.passwordLoading = true;
      this.updatePasswordFunction({ email: this.useremail, newPassword: this.password}).subscribe(async (res) => {
        if (res && res.error) {
          this.passwordLoading = false;
          this.showError = true;
        } else {
          this.useremail = '';
          this.password = '';
          this.passwordLoading = false;
          this.showPasswordSuccess = true;
          const self = this;
          setTimeout(function() {
            self.showPasswordSuccess = false;
          }, 1500);
        }
      });
    }
  }

}
